var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { AsyncRequestStatus, getCompletedAsyncWrapperObj, getDefaultAsyncWrapperObj } from "@ane/core/lib/models";
const prefix = "OVERRIDE_GATES";
const createActionTypes = (resource) => ({
  LOAD: `${prefix}/${resource}/LOAD'`,
  LOADING: `${prefix}/${resource}/LOADING'`,
  LOADED: `${prefix}/${resource}/LOADED'`
});
const overrideGateActionTypes = createActionTypes("OVERRIDE_GATE");
const resolveGate = (payload) => {
  return {
    type: overrideGateActionTypes.LOAD,
    payload
  };
};
const resolvingGate = () => {
  return {
    type: overrideGateActionTypes.LOADING,
    payload: {
      status: AsyncRequestStatus.Pending
    }
  };
};
const gateResolved = (payload) => {
  return {
    type: overrideGateActionTypes.LOADED,
    payload: getCompletedAsyncWrapperObj(payload.data, payload.error || "")
  };
};
const defaultReducerState = {
  async: getDefaultAsyncWrapperObj()
};
const overrideGateReducer = (state = defaultReducerState, action) => {
  switch (action.type) {
    case overrideGateActionTypes.LOADING:
    case overrideGateActionTypes.LOADED:
      return __spreadProps(__spreadValues({}, state), {
        async: action.payload
      });
    default:
      return state;
  }
};
export {
  createActionTypes,
  defaultReducerState,
  gateResolved,
  overrideGateActionTypes,
  overrideGateReducer,
  resolveGate,
  resolvingGate
};
//# sourceMappingURL=OverrideGate.ducks.js.map
